import { formatQuery, RuleGroupType } from "react-querybuilder";
import { parseJsonLogic } from "react-querybuilder/parseJsonLogic";
import { RuleSetEditorData, RuleSet, Rule } from "../../types/ruleSetTypes";

const convertToRuleList = (ruleGroup: RuleGroupType): Rule[] => {
  if (ruleGroup.rules.length === 0) {
    return [];
  }

  // The React Query Builder rule group has a top level "or" node.
  // We want the list of rules within that "or" node.
  const jsonLogic = formatQuery(ruleGroup, { format: 'jsonlogic', parseNumbers: true }) as any;
  const jsonLogicList = jsonLogic.or as [any];

  return jsonLogicList.map((rule) => {
    return {
      ruleDefinition: rule
    } as Rule;
  });
}

export const convertToRuleSet = (data: RuleSetEditorData): RuleSet => {
  return {
    id: data.ruleSetId,
    name: data.name,
    description: data.description,
    acceptRules: convertToRuleList(data.acceptQuery),
    rejectRules: convertToRuleList(data.rejectQuery),
    reviewRules: convertToRuleList(data.reviewQuery),
    concurrentModificationGuard: data.concurrentModificationGuard
  };
}

export const convertToQueryBuilderRuleGroup = (rules?: Rule[]): RuleGroupType => {
  if (!rules) {
    return { combinator: "or", rules: [] };
  }
  
  // If the ruleDefinition is not either an "and" or "or" JsonLogic node, then parseJsonLogic
  // will return a RuleGroupType with an "and" combinator. We don't want that, since we are adding
  // the list of rules to an "or" combinator anyway.
  // To prevent parseJsonLogic from adding a top level "and" combinator to the resulting RuleGroupType,
  // we wrap the ruleDefinition in an "and" node. Then we parse the JsonLogic and extract rule[0],
  // thereby discarding and added "and" combinator.

  var queryBuilderRuleGroup: RuleGroupType = { combinator: "or", rules: [] };

  for (var rule of rules) {
    var wrappedRule = { and: [ rule.ruleDefinition ] };
    var parsedRule = parseJsonLogic(wrappedRule).rules[0]; // unwrap the "and" node
    parsedRule.id = rule.id;
    queryBuilderRuleGroup.rules.push(parsedRule);
  }

  return queryBuilderRuleGroup;
}